const TZ = 'Europe/Amsterdam';
const BUFFER_MS = 15 * 60 * 1000;

function amsterdamParts(date) {
  const fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  const map = Object.fromEntries(
    fmt.formatToParts(date).filter((p) => p.type !== 'literal').map((p) => [p.type, p.value])
  );
  return { y: map.year, mo: map.month, d: map.day, h: map.hour, mi: map.minute };
}

function dateIso(parts) {
  return `${parts.y}-${parts.mo}-${parts.d}`;
}

function timeHhmm(parts) {
  return `${parts.h}:${parts.mi}`;
}

export function normalizeTimeHhmm(raw, fallback = '10:00') {
  const t = String(raw || fallback).trim().slice(0, 5);
  return /^\d{1,2}:\d{2}$/.test(t) ? t : fallback;
}

function compareScheduleDayTime(dayIso, timeHhmm, refDate) {
  const day = String(dayIso || '').slice(0, 10);
  const time = normalizeTimeHhmm(timeHhmm);
  const ref = amsterdamParts(refDate);
  const today = dateIso(ref);
  if (day > today) return 1;
  if (day < today) return -1;
  const refM = parseInt(ref.h, 10) * 60 + parseInt(ref.mi, 10);
  const [hh, mm] = time.split(':');
  const schedM = parseInt(hh, 10) * 60 + parseInt(mm, 10);
  if (schedM > refM) return 1;
  if (schedM < refM) return -1;
  return 0;
}

export function minimumForwardSchedule(defaultPublishTime = '10:00', nowMs = Date.now()) {
  const minDate = new Date(nowMs + BUFFER_MS);
  const minParts = amsterdamParts(minDate);
  const minDay = dateIso(minParts);
  const minTime = timeHhmm(minParts);
  const preferred = normalizeTimeHhmm(defaultPublishTime);

  let startsOn = minDay;
  let publishTime = preferred;
  if (compareScheduleDayTime(startsOn, publishTime, minDate) < 0) {
    publishTime = minTime;
  }
  return { startsOn, publishTime };
}

/** Alleen formaat normaliseren — geen 15-min buffer (handmatige planning). */
export function normalizeSchedule(startsOn, publishTime, defaultPublishTime = '10:00') {
  const time = normalizeTimeHhmm(publishTime, normalizeTimeHhmm(defaultPublishTime));
  const day = String(startsOn || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return minimumForwardSchedule(defaultPublishTime);
  }
  return { startsOn: day, publishTime: time };
}

/** Standaard bij nieuwe posts: minstens 15 min vooruit. Handmatig opslaan: gebruik normalizeSchedule. */
export function ensureForwardSchedule(startsOn, publishTime, defaultPublishTime = '10:00', nowMs = Date.now()) {
  const minDate = new Date(nowMs + BUFFER_MS);
  const day = String(startsOn || '').slice(0, 10);
  const time = normalizeTimeHhmm(publishTime, normalizeTimeHhmm(defaultPublishTime));
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) {
    return minimumForwardSchedule(defaultPublishTime, nowMs);
  }
  if (compareScheduleDayTime(day, time, minDate) >= 0) {
    return { startsOn: day, publishTime: time };
  }
  const minParts = amsterdamParts(minDate);
  const minDay = dateIso(minParts);
  if (day > minDay) {
    return { startsOn: day, publishTime: time };
  }
  if (day === minDay) {
    return { startsOn: day, publishTime: timeHhmm(minParts) };
  }
  return minimumForwardSchedule(defaultPublishTime, nowMs);
}
